export const PREMIER_ORDER_STATUS_ACTIVE = 1;
export const PREMIER_ORDER_STATUS_IN_ACTIVE = 0;
